import {Guid, ITCIServiceContribution, TCI_MODULE_CONTRIBUTION} from "@tci/common";

export class TciContribModuleMap {
    private static instance: TciContribModuleMap;
    id: string;
    private _moduleMap: Map<string, TCI_MODULE_CONTRIBUTION<ITCIServiceContribution>>
        = new Map<string, TCI_MODULE_CONTRIBUTION<ITCIServiceContribution>>();

    public static getInstance(): TciContribModuleMap {
        if (!TciContribModuleMap.instance) {
            TciContribModuleMap.instance = new TciContribModuleMap();
        }
        return TciContribModuleMap.instance;
    }

    constructor() {
        this.id = Guid.newGuid();
    }

    /**
     * sets the module map
     * @private
     * @param {Map<string, TCI_MODULE_CONTRIBUTION<IWiServiceContribution>>} mmap
     */
    set moduleMap(mmap: Map<string, TCI_MODULE_CONTRIBUTION<ITCIServiceContribution>>) {
        this._moduleMap = mmap;
    }

    /**
     * Returns the module map
     * @private
     * @return {Map<string, TCI_MODULE_CONTRIBUTION<IWiServiceContribution>>}
     */
    get moduleMap() {
        return this._moduleMap;
    }

}
